import { FALLBACK_NUMBER_VALUE, FALLBACK_VALUE } from 'constants/uiSettings';

const getSkillMatchData = (
  allSkillsQuantity: number | undefined,
  matchSkillsQuantity: number | undefined = FALLBACK_NUMBER_VALUE
): { colorVarName: string; matchString: string } => {
  if (!allSkillsQuantity) {
    return { colorVarName: '--red-darken', matchString: FALLBACK_VALUE };
  }

  const matchLevelPercent = (matchSkillsQuantity / allSkillsQuantity) * 100;
  const matchString = `${matchSkillsQuantity}/${allSkillsQuantity}`;

  let colorVarName = '';

  switch (true) {
    case matchLevelPercent >= 80:
      colorVarName = '--green-darken';
      break;
    case matchLevelPercent >= 50:
      colorVarName = '--yellow-darken';
      break;
    case matchLevelPercent >= 20:
      colorVarName = '--orange-darken';
      break;
    default:
      colorVarName = '--red-darken';
  }

  return { colorVarName, matchString };
};

export default getSkillMatchData;
